<div class="pr-panel-footer" [ngClass]="clazz">
  <ng-content></ng-content>
</div>
